import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from '../components/common/AdminMobileSearchInput';
import AdminMobileMachList from '../components/AdminMobileMachList';

// 탭 버튼 카테고리
import categories from 'routes/adminMobile/commonVar/machineCategory';
import AdminMobileTabbtnBox from '../components/common/AdminMobileTabbtnBox';

// 자판기 테스트 데이터
import testMachineData from 'routes/adminMobile/commonVar/testMachineData';

const AdminMobileMachine = () => {
    // 검색어 상태 관리
    const [searchKeyword, setSearchKeyword] = useState('');
    

    // 현재 선택된 카테고리를 상태로 관리
    const [selectedCategory, setSelectedCategory] = useState(categories[0].name);
    

    // 필터링된 자판기 리스트를 상태로 관리
    
    const [filteredMachines, setFilteredMachines] = useState([]);

    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };

    // 탭 버튼을 클릭하여 카테고리 변경
    const handleTabChange = (categoryName) => {
        setSelectedCategory(categoryName);
    };

    useEffect(() => {
        // 선택된 카테고리에 따라 자판기 리스트 필터링
        let filtered = testMachineData;
        if (selectedCategory !== 'all') {
            filtered = filtered.filter(mach => mach.machineWork === selectedCategory);
        }
    
        // 검색어가 있으면 해당 검색어를 포함하는 유저 필터링
        if (searchKeyword) {
            filtered = filtered.filter(mach => 
                mach.machineAffiliation.toLowerCase().includes(searchKeyword.toLowerCase())
            );
        }
    
        setFilteredMachines(filtered);
    }, [searchKeyword, selectedCategory]);

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>자판기 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="매장을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 탭 버튼 기능 */}
                        <AdminMobileTabbtnBox 
                            categories={categories}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={handleTabChange}
                        />
                    </FlexChild>
                    <FlexChild>
                        {/* 자판기 리스트 출력 */}
                        <AdminMobileMachList machines={filteredMachines} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};
 
export default AdminMobileMachine;